module.exports = __webpack_public_path__ + "img/29739607_2020680068220520_4509928046932787200_n.277f0ac1.jpg";